import {
  GET_ADDRESS_FORMAT_OBJECT_REQUESTING,
  GET_ADDRESS_FORMAT_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ADDRESS_FORMAT_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_ADDRESS_FORMAT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.code] = action.payload;

      return {
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
